import API from './API';

export default {
  login(loginData) {
    // niente log qui: conteneva USERNAME E PASSWORD in chiaro in console
    return API.post('/auth/login/', loginData);
  },

  resetPassword(mail){
    return API.get('/auth/reset-password/'+mail)
  },

  // Rinvio dell'accesso a un utente che non ha ricevuto la mail: stesso
  // flusso del "password dimenticata", quindi gli arriva un link per
  // sceglierla lui e la password che ha ora resta valida finché non lo usa.
  //
  // POST e non la GET qui sopra: con la mail nel path l'indirizzo finisce
  // nell'URL, e quindi nei log del server e nella cronologia del browser.
  // Il backend risponde sempre "accepted", anche per una mail inesistente
  // (serve a non far scoprire quali indirizzi esistono): l'esito dell'invio
  // non si può quindi mostrare, e il messaggio non deve prometterlo.
  sendPasswordLink(mail) {
    return API.post('/auth/reset-password', { mail }, { skipErrorToast: true });
  },

  // Rinvio della mail di BENVENUTO (utente e password) a un dipendente. La
  // password di allora non è recuperabile: il server ne genera una nuova, che
  // sostituisce la vecchia, e la restituisce anche qui. Solo Simba.
  resendCredentials(employeeId) {
    return API.post('/auth/resend-credentials', { employeeId });
  },
};